<template>
  <div>
    <div class="has-loader" v-if="form">
      <div class="loader" :class="{ loaded: !processing }">
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
      </div>
      <fieldset :disabled="readonly">
        <legend>
          <span>
            {{ heading }}
            <small class="text-muted"> - {{ helper }} </small>
          </span>
        </legend>

        <div v-if="displayCompanyLookup">
          <div class="form-group has-helper">
            <div :class="{ 'col-md-4': !stacked }">
              <label for="" class="control-label">Choose Company:</label>
              <p class="help-block">
                Please choose a company from the list. If you cannot find the
                company, click the "Enter Manually" button.
              </p>
            </div>
            <div :class="{ 'col-md-8': !stacked }">
              <selectlist
                name="company"
                :options="companies"
                :stacked="false"
                label-name="name"
                v-model="form.company_id"
              ></selectlist>
              <!--              <div class="row">-->
              <!--                <div class="col-lg-4">-->
              <!--                  <label class="control-label">Company</label>-->
              <!--                </div>-->
              <!--                <div class="col-lg-8">-->
              <!--                  <select-->
              <!--                    name="company"-->
              <!--                    v-model="form.company_id"-->
              <!--                    class="form-control"-->
              <!--                  >-->
              <!--                    <option value="">Please Select</option>-->
              <!--                    <option-->
              <!--                      :key="company.id"-->
              <!--                      :value="company.id"-->
              <!--                      v-for="company in companies"-->
              <!--                    >-->
              <!--                      {{ company.name }}-->
              <!--                    </option>-->
              <!--                  </select>-->
              <!--                </div>-->
              <!--              </div>-->

              <button
                class="btn btn-primary btn-block half-gutter-top"
                type="button"
                v-on:click.prevent="setToManual"
              >
                Enter Manually
              </button>
            </div>
          </div>
        </div>
        <div v-if="!displayCompanyLookup">
          <div>
            <inputbox
              v-model="form.name"
              name="name"
              label="Company Name"
              :required="true"
              :error-message="form.errors.get('name')"
              helper="Please enter the company name"
              :show-error="form.errors.has('name')"
            ></inputbox>

            <inputbox
              v-model="form.email_address"
              name="email_address"
              label="Email Address"
              :error-message="form.errors.get('email_address')"
              helper="Please enter the company email address"
              :show-error="form.errors.has('email_address')"
            ></inputbox>

            <inputbox
              v-model="form.telephone_number"
              name="telephone_number"
              label="Telephone Number"
              :error-message="form.errors.get('telephone_number')"
              helper="Please enter the company telephone number"
              :show-error="form.errors.has('telephone_number')"
            ></inputbox>

            <address-lookup
              :address="address"
              v-on:address="setAddress"
            ></address-lookup>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
let companySelectCount = 0;

import Form from './../../../Classes/Form';

export default {
  props: {
    types: {
      type: Array,
      default: () => []
    },
    stacked: {
      type: Boolean,
      default: false
    },
    company: Object,
    heading: {
      type: String,
      default: 'Company Details'
    },
    helper: {
      type: String,
      default: 'Enter the details of company'
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      manual: false,
      companySelectId: undefined,
      values: {},
      displayCompanyLookup: true
    };
  },

  computed: {
    form() {
      return this.values[this.companySelectId];
    },

    processing() {
      return this.form?.processing() || false;
    },

    companies() {
      return this.$store.getters['Companies/all'].filter(company => {
        if (this.types.length) {
          return company.types?.some(
            type => this.types.indexOf(type.name) > -1
          );
        }

        return true;
      });
    },

    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  mounted() {
    this.$store.commit('Companies/retrieve');

    companySelectCount++;

    this.companySelectId = companySelectCount;

    this.values[this.companySelectId] = new Form({
      company_id: this.company?.company_id,
      name: this.company?.name,
      email_address: this.company?.email_address,
      telephone_number: this.company?.telephone_number,
      address_line_one: this.company?.address_line_one,
      address_line_two: this.company?.address_line_two,
      city: this.company?.city,
      postcode: this.company?.postcode
    });

    this.checkIfLookupShouldDisplay();

    // if (this.getAllCompanies.length) {
    //   this.companies = this.getSelectedCompanies(this.getAllCompanies);
    // } else {
    //   window.Ajax.get(`/companies`)
    //     .then(response => {
    //       this.companies = this.getSelectedCompanies(response.data);
    //     })
    //     .catch(error => {});
    // }
  },

  methods: {
    setToManual() {
      this.manual = true;
      this.displayCompanyLookup = false;
      this.form.company_id = null;
    },
    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },
    checkIfLookupShouldDisplay() {
      this.displayCompanyLookup = !this.form.name && !this.manual;

      this.$forceUpdate();
    }
  },
  watch: {
    company() {
      if (Object.keys(this.company).length > 0) {
        this.form.company_id = this.company.company_id;
        this.form.name = this.company.name;
        this.form.email_address = this.company.email_address;
        this.form.telephone_number = this.company.telephone_number;
        this.form.address_line_one = this.company.address_line_one;
        this.form.address_line_two = this.company.address_line_two;
        this.form.city = this.company.city;
        this.form.postcode = this.company.postcode;

        this.checkIfLookupShouldDisplay();
      }
    }
  }
};
</script>
